import React, { useState, useEffect, useMemo, Children } from "react";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Table,
} from "reactstrap";
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { callAPI } from "../../_helper/index";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
import ReactTableComponent from "../../components/Table/ReactTableComponent";
import Select from "react-dropdown-select";
import { Spinner } from 'reactstrap';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
function Orders() {
  const COLUMNS = [
    {
      Header: "Action",
      Footer: "Action",
      accessor: (originalRow, rowIndex) => {
        return (
          <>

            <UncontrolledDropdown className="menu-dropdown">
              <DropdownToggle>
                <div className="dots"></div>
                <div className="dots"> </div>
                <div className="dots"></div>
              </DropdownToggle>
              <DropdownMenu>

                <Row>
                  <Col>
                    <button
                      data-tip
                      data-for="EditOrder"
                      onClick={(e) => {
                        history.push(`/admin/manage-order/${originalRow.Id}`);
                      }}
                      className="btn-edit"
                    >

                      <i className="now-ui-icons design-2_ruler-pencil" />
                      Edit
                    </button>
                    <ReactTooltip id="EditOrder" place="top" effect="solid">
                      Edit Order
                    </ReactTooltip>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <button
                      data-tip
                      data-for="DeleteOrder"
                      onClick={(e) => deleteOrders(originalRow.Id)}
                      className="btn-edit"
                    >
                      <i className="now-ui-icons ui-1_simple-remove" />
                      Delete
                    </button>
                    <ReactTooltip id="DeleteOrder" place="top" effect="solid">
                      Delete Order
                    </ReactTooltip>
                  </Col>
                </Row>

              </DropdownMenu>
            </UncontrolledDropdown>

          </>
        );
      },
      Cell: ({ value }) => {

        return value;
      },
    },
    {
      Header: "Order Number",
      Footer: "Order Number",
      accessor: "OrderNumber",
    },
    {
      Header: "Receiver Name",
      Footer: "Receiver Name",
      accessor: "FirstName",
    },
    {
      Header: "Address",
      Footer: "Address",
      accessor: "Address",
    },
    {
      Header: "Contact Number",
      Footer: "Contact Number",
      accessor: "ContactNumber",
    },
    {
      Header: "Order Status",
      Footer: "Order Status",
      accessor: "StatusName",
    },
    {
      Header: "Trip Number",
      Footer: "Trip Number",
      accessor: "TripNumber",
    },
  ];
  const [orderStatus, setOrderStatus] = useState([]);
  const [orders, setOrders] = useState([]);
  const history = useHistory();

  const columns = useMemo(() => COLUMNS, []);
  const data = useMemo(() => orders, []);
  const [userData, setuserData] = useState([])
  const [dropDownList, setdropDownList] = useState([
    { label: "All", value: "all", }
  ])
  const [IsLoading, setIsLoading] = useState(true)
  useEffect(() => {
    loadOrderStatus();
    loadOrders(0);
  }, []);


  const loadOrderStatus = (status) => {
    var response = callAPI(`/api/order-status`, "GET", null);
    response.then((res) => {
      if (res.success) {
        setOrderStatus(res.data);
        setIsLoading(false)
      } else {
        toast.error(res.message);
      }
    });
  };

  const onInputChange = (e) => {
    e.preventDefault();
    loadOrders(e.target.value);
  };

  const loadOrders = (status) => {
    var response = callAPI(`/api/orders/0/${status}`, "GET", null);
    response.then((res) => {
      if (res.success) {
        setOrders(res.data);
        setIsLoading(false)
      } else {
        toast.error(res.message);
      }
    });
  };

  const deleteOrders = async (id) => {

    if (confirm("Are you sure you want to delete this order?")) {
      setIsLoading(true)
      var response = callAPI(`/api/orders/${id}`, "DELETE", null);
      response.then((res) => {
        setIsLoading(false)
        if (res.success) {
          toast.success("Order Deleted Successfully!!!");
          loadOrders(0);
        } else {
          toast.error(res.message);
        }
      });
    }
  };

  let renderRow = orders.map((order) => {
    return (
      <tr key={order.Id}>
        <td className="td-actions text-left">
          <button
            data-tip
            data-for="EditOrder"
            onClick={(e) => {
              history.push(`/admin/manage-order/${order.Id}`);
            }}
            className="btn btn-info"
          >
            <i className="now-ui-icons design-2_ruler-pencil" />
          </button>
          <ReactTooltip id="EditOrder" place="top" effect="solid">
            Edit Order
          </ReactTooltip>
          &nbsp;
          <button
            data-tip
            data-for="DeleteOrder"
            onClick={(e) => deleteOrders(order.Id)}
            className="btn btn-danger"
          >
            <i className="now-ui-icons ui-1_simple-remove" />
          </button>
          <ReactTooltip id="DeleteOrder" place="top" effect="solid">
            Delete Order
          </ReactTooltip>
        </td>
        <td className="text-left">{order.OrderNumber}</td>
        <td className="text-left">{order.FullName}</td>
        <td className="text-left">
          {order.Address} <br />
          {order.City}, {order.State} {order.Zip} <br />
          Lat: {order.Lat} <br />
          Long: {order.Long}
        </td>
        <td className="text-left">{order.ContactNumber}</td>
        <td className="text-left">{order.StatusName}</td>
        <td className="text-left">{order.TripNumber}</td>
      </tr>
    );
  });

  let renderStatusOptions =
    orderStatus.length > 0 || orderStatus.roles != undefined
      ? orderStatus.map((st) => {
        return (
          <option key={st.Id} value={st.Id}>
            {st.Status}
          </option>
        );
      })
      : "";


  useEffect(() => {
    let arr = [
      { label: "aa", value: "1" },
      { label: "bb", value: "2" },
      { label: "cc", value: "54" },
    ]
    setuserData(arr)
  }, [])


  return (
    <>
      <PanelHeader size="lg" />
      {
        IsLoading &&
        <div className="loader">
          <Spinner color="white" />
        </div>

      }
      <div className="content">
        <Row>
          <Col xs={12} md={12}>
            <Card className="card-chart">
              <CardHeader>
                <Row>
                  <Col md={4}>
                    <CardTitle tag="h4">
                      Orders Management
                    </CardTitle>
                  </Col>
                  {/* <Col md={3} className="mt-2">
                    <Select
                      name="UserName"
                      className="form-control rounded store-dropdown p-2"
                      placeholder="search UserName.."
                      options={userData}
                      onChange={(value) => onUserDataChange(value)}
                      values={dropDownList}
                    />
                  </Col> */}
                  <Col md={3}>
                    <select
                      name="Status"
                      id="ddlOrderStatus"
                      className="form-control h38"
                      onChange={(e) => onInputChange(e)}
                    >
                      <option value="0">All</option>
                      { }
                      {renderStatusOptions}
                    </select>
                  </Col>

                  <Col className="text-right" md>
                    <button
                      className="btn btn-info"
                      onClick={(e) => {
                        history.push("/admin/manage-order");
                      }}
                    >
                      Add Order
                    </button>
                  </Col>
                </Row>

              </CardHeader>
              <CardBody>
                {orders.length ? (
             
                  <ReactTableComponent data={orders} columns={columns} />
               
                ) : null}
                {/* <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Action</th>
                      <th>Order Number</th>
                      <th>Receiver Name</th>
                      <th>Address</th>
                      <th>Contact Number</th>
                      <th>Order Status</th>
                      <th>Trip Number</th>
                    </tr>
                  </thead>
                  <tbody>{renderRow}</tbody>
                </Table>
               */}
              </CardBody>
              <CardFooter>
                <div className="stats"></div>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Orders;
